module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-minus-39b95fb23a3bc70ffa9e44ebae66aeb6.svg";